module.exports = __webpack_public_path__ + "static/level-1-card.a3e16e47.png";